import React, { useState, useEffect } from 'react';
import ProfileCard from './ProfileCard';
import BioModal from './BioModal';
import './LeadershipSection.css';

// Leadership team data with images from public folder
// Order: 4 cards in row 1, 4 in row 2
// Row 1: Sanjeev, John, Judith, Hitesh
// Row 2: Chaitanya, Atul, David, Mohit
const leadershipTeam = [
  {
    id: 1,
    name: 'Sanjeev Gupta',
    role: 'CEO',
    image: '/team/Sanjeev Gupta.png',
    linkedInUrl: 'https://www.linkedin.com/in/sanjeev/',
    bio: [
      "Sanjeev is a seasoned enterprise software executive with over 25 years of experience building and scaling large, complex systems. He co-founded Kahuna Labs drawing on his deep background in customer experience, product innovation and go-to-market strategy. Prior to that, he led New Product Introduction at Palo Alto Networks, where his team launched 200+ new offerings—including the integration of 14 acquisitions—across the company's product portfolio.",
      "Earlier in his career, Sanjeev was part of several high-growth enterprise software companies, including Model N and Castlight Health, both of which went public during his tenure. He also led Global Customer Solutions at Google, driving adoption and success for large-scale enterprise deployments.",
      "Sanjeev holds an MBA from IIM Lucknow and a B.Tech in Computer Science from IIT Delhi."
    ],
  },
  {
    id: 2,
    name: 'John Ragsdale',
    role: 'SVP, Marketing',
    image: '/team/John Ragsdale.png',
    linkedInUrl: 'https://www.linkedin.com/in/jkragsdale/',
    bio: [
      "John is a preeminent thought leader and strategic authority in technical support technology ecosystems. With over two decades at the industry's forefront, his perspective is one of unparalleled depth: forged from running support centers and leading product strategy at major CRM vendors, and sharpened during his influential tenure as a leading analyst at Forrester and TSIA.",
      "John now advises and influences our mission to radically transform technical support. He applies the strategic vision gained from his work with hundreds of global service leaders to architect an AI-infused, high-performance, future-state support model that defines a new standard for technology services excellence."
    ],
  },
  {
    id: 3,
    name: 'Judith Platz',
    role: 'Field Chief Customer Officer',
    image: '/team/Judith.png',
    linkedInUrl: 'https://www.linkedin.com/in/judithaplatz/',
    bio: [
      "Judith Platz is a widely respected industry authority and strategic leader in customer experience, support operations, and post-sales transformation. With more than two decades shaping the future of customer success and technical support, her expertise is uniquely multidimensional; built from leading global support and customer success organizations, driving product and customer strategy at high-growth SaaS companies, and advising some of the world's most recognizable enterprise brands.",
      "Judith's leadership perspective has been forged through hands-on executive roles spanning Customer Success, Support, Services, Product, and Experience, including senior leadership positions at organizations such as TSIA, Salesforce, Mulesoft, and SupportLogic. She has guided organizations through massive scale, operational redesign, and the integration of AI, predictive insights, and experience-led design. Throughout her career, she has partnered with hundreds of CX and support executives across industries, helping them modernize operations, elevate customer value, and build more intelligent, proactive engagement models.",
      "Today, Judith applies this depth of experience to shaping the next era of customer and product excellence. She is a vocal advocate for unifying customer understanding, operational execution, and product strategy; empowering companies to build AI-driven, high-performance ecosystems where customer insight fuels innovation. Her work will influence how modern enterprises design, scale, and deliver exceptional experiences across the entire customer journey."
    ],
  },
  {
    id: 4,
    name: 'Hitesh Sharma',
    role: 'Chief Development Officer',
    image: '/team/Hitesh.png',
    linkedInUrl: 'https://www.linkedin.com/in/hitesh-sharma-712a88/',
    bio: [
      "Hitesh builds engineering teams that thrive at the intersection of scale, performance, and innovation. With more than two decades of experience leading platform and infrastructure development at Cohesity, Datrium, and NetApp, he's helped deliver technologies that protect and move the world's data — reliably and at massive scale – and powered hundreds of millions in enterprise revenue.",
      "At Kahuna Labs, Hitesh brings that same rigor and curiosity to the world of AI infrastructure. He believes that building great technology starts with empowering great people — and that thoughtful engineering can make complex AI systems not just faster, but smarter and more trustworthy.",
      "Hitesh holds a B.Tech. in Computer Science and Engineering from IIT Delhi."
    ],
  },
  {
    id: 5,
    name: 'Chaitanya Potluri',
    role: 'Co-Founder and Head of Technology',
    image: '/team/Chaitanya.png',
    linkedInUrl: 'https://www.linkedin.com/in/cpotluri/',
    bio: [
      "Chaitanya focuses on dependable AI systems that deliver value to frontline teams. At Kahuna Labs his work centers on engineering the last mile where AI collaborates with people, learns from feedback, and steadily improves outcomes.",
      "Previously he led data platform and engineering at Keystone, partnering with leading technology companies on complex problems involving large-scale data. Before that he worked in research at Carnegie Mellon University.",
      "Co-founding Kahuna has reinforced his belief that the future of frontline productivity lies in systems that surface the right context at the right moment, listen before they act, and close the loop in ways that are easy to verify. Chaitanya holds a master's degree in Information Systems from Carnegie Mellon University and a bachelor's in Electronics Engineering from the National Institute of Technology, Surat."
    ],
  },
  {
    id: 6,
    name: 'Atul Nanda',
    role: 'Executive Advisor',
    image: '/team/AtulNanda.png',
    linkedInUrl: 'https://www.linkedin.com/in/nandaatul',
    bio: [
      "Atul has transformed some of the most complex frontline organizations on this planet. As part of Google Cloud's senior leadership team, Atul transformed and led Global Support & Premium Services for GCP and Workspace, participated in designing the overall customer experience strategy, managed a $500M+ P&L and a global team of 5,000+ Googlers & vendors, supporting Google Cloud revenue growth from ~$8B to $25B in three years.",
      "As SVP and Chief Support Officer of Salesforce, he led Technical Support globally to help materialize revenue growth from <$1B to $16.5B. As a member of the Executive team that pioneered Customer Success in the Cloud, Atul built and led Customer Success Centers worldwide. In addition, Atul built and scaled Onboarding, Accelerators, and company-wide Red Accounts program to help prevent churn, drive renewals, and accelerate revenue.",
      "Most recently at Atlassian, Atul led Atlassian's Global Support delivery organization, encompassing Technical Support, Support Account Management, and Incident & Escalation Management across the full product portfolio. Atul served as an advisory board member of TSIA for over a decade and is currently a Founding Member of the Advisory Board at SuccessLab, an organization that brings together senior leaders to shape the future of CSS in the age of AI.",
      "Atul is committed to accelerating AI adoption, driving customer value, sparking innovation, and building scalable frameworks for governance, change, and results across the industry. He helps support leaders bring transformational results using Kahuna AI, and materialize productivity leap for Technical Support."
    ],
  },
  {
    id: 7,
    name: 'David Hare',
    role: 'Executive Advisor',
    image: '/team/DavidHare.png',
    linkedInUrl: 'https://www.linkedin.com/in/dave-hare-966b6/',
    bio: [
      "David Hare is a seasoned service and support executive with over 30 years of experience building, scaling, and leading world-class global customer support organizations. He has held senior leadership roles at enterprise technology companies including Oracle, PeopleSoft, Deltek, Redback Networks, Aspect Communications, and Baan, where he led worldwide and global support operations spanning international and offshore teams.",
      "David is widely recognized for driving operational excellence, customer satisfaction, and profitable service delivery at scale. He was part of the leadership team at J.D. Power and Associates' first enterprise software company to be globally certified for Outstanding Customer Service Excellence and has received multiple industry awards recognizing his commitment to service leadership and best practices.",
      "In addition to his executive roles, David has been deeply involved in the service leadership community, serving as an advisor and former director with organizations such as TSIA, the Center for Service Leadership, the Association of Technology and Women, and AFSMI. As an Executive Advisor to Kahuna Labs, David brings a practitioner's perspective on modernizing technical support and leveraging AI to drive better outcomes for both customers and enterprises."
    ],
  },
  {
    id: 8,
    name: 'Mohit Aron',
    role: 'Executive Advisor',
    image: '/team/MohitAron.png',
    linkedInUrl: 'https://www.linkedin.com/in/mohit-aron-a83858/',
    bio: [
      "Mohit has over 20 years of experience in building scalable, high-performance distributed systems, and has been attributed as the father of hyperconvergence.",
      "Mohit founded Cohesity in 2013 and has grown the company into a leading provider of next-gen data management. He also co-founded Nutanix as the CTO, now a public company and leader in hyperconverged technology, in 2009. Prior to co-founding Nutanix, Mohit was at Google as a lead developer on the Google File System, the software that manages data on Google's large scale clusters.",
      "Aron graduated with a Ph.D. in computer science from Rice University with a focus on distributed systems. He also holds a bachelor of science in computer science from the Indian Institute of Technology, Delhi India. In 2018, he received the \"Outstanding Engineering Alumni Award\" from Rice University and also received the Distinguished Alumni Award from IIT Delhi in 2019."
    ],
  },
];

const LeadershipSection = () => {
  const [selectedLeader, setSelectedLeader] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleBioClick = (leader) => {
    setSelectedLeader(leader);
    setIsModalOpen(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedLeader(null);
    // Restore body scroll
    document.body.style.overflow = 'unset';
  };

  return (
    <section className="leadership">
      {/* Background Gradients */}
      <div className="leadership__bg-left" />
      <div className="leadership__bg-right" />

      {/* Content */}
      <div className="leadership__content">
        {/* Header */}
        <div className="leadership__header">
          <span className="leadership__tag">Our Leadership</span>
          <h2 className="leadership__title">
            {isMobile ? (
              <>
                <span>Passionate for </span> <br />
                <span>Making the Frontline</span> <br />
                <span>Productivity Leap</span>
              </>
            ) : (
              <>
                <span>Passionate for Making</span> <br />
                <span>the Frontline Productivity Leap</span>
              </>
            )}
          </h2>
        </div>

        {/* Cards */}
        <div className="leadership__cards">
          {/* Row 1 - 4 cards */}
          <div className="leadership__row leadership__row--first">
            {leadershipTeam.slice(0, 4).map((leader) => (
              <ProfileCard
                key={leader.id}
                name={leader.name}
                role={leader.role}
                image={leader.image}
                linkedInUrl={leader.linkedInUrl}
                onBioClick={() => handleBioClick(leader)}
              />
            ))}
          </div>

          {/* Row 2 - 4 cards */}
          <div className="leadership__row leadership__row--second">
            {leadershipTeam.slice(4, 8).map((leader) => (
              <ProfileCard
                key={leader.id}
                name={leader.name}
                role={leader.role}
                image={leader.image}
                linkedInUrl={leader.linkedInUrl}
                onBioClick={() => handleBioClick(leader)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Bio Modal */}
      <BioModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        leader={selectedLeader}
      />
    </section>
  );
};

export default LeadershipSection;

